const OddsStatus = ({ trend }) => {
  const t = String(trend || "");
  const isUp = t === "up" || t === "increased";
  const isDown = t === "down" || t === "decreased";
  if (!isUp && !isDown) return null;
  return (
    <span
      className={`inline-block w-0 h-0 border-l-[0.3125rem] border-r-[0.3125rem] border-l-transparent border-r-transparent ${
        isUp ? "border-b-[0.54rem] border-b-[#22c55e]" : "border-t-[0.54rem] border-t-[#ef4444]"
      }`}
    />
  );
};

export default OddsStatus;
